export default __webpack_public_path__ + "static/media/result8.3cda5977.png";